import './image-list.print.scss';
import { useCallback, useState } from 'react';
import { SelectCondition } from '../print-order-preparation';
import { ImagesGetResponse } from '../../../../../api/front/images/api-images';
import { PrintImage } from './print-image';
import { PrintImagesDataEntity } from '../../../../../api/sift/front/api-print-image';
import { FaPlus } from "react-icons/fa6";
import { Button } from '../../../../ui/button/button';
import { ProgressBar } from '../../../../ui/progress-bar/progress-bar';
import { TrimEditableImage } from '../../../../../trim-editor/manager/image-edit/trim.editable-image';
import { CiCirclePlus } from 'react-icons/ci';
import { usePrintUploadFiles } from '../../hooks/use-print-upload-files';

type Props = {
  imgData: PrintImagesDataEntity[],
  kijshopCd: string,
  shopOrderId: string,
  imageUpload: (uploadFiles: File[]) => void,
  progressView: string,
  ordered: boolean,
  progress: {
    queue: number;
    done: number;
    error: number;
  } | null,
}

export const PrintImageList = (props: Props) => {
  const {
    imgData,
    kijshopCd,
    shopOrderId,
    ordered,
    progressView,
    progress,
    imageUpload,
  } = props;
  const { filterUploadFiles } = usePrintUploadFiles();
  const [open, setOpen] = useState(false);
  const onClickImageAdd = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpg, image/jpeg';
    input.multiple = true;
    input.onchange = async (event: any) => {
      const e = event as React.ChangeEvent<HTMLInputElement>;
      const uploadFiles = Array.from(e.target.files ?? []);
      const sequential = await filterUploadFiles(uploadFiles);
      if (!sequential.length) {
        return;
      }

      imageUpload(sequential);
    }
    input.click();
    input.remove();

  }, [
    imageUpload,
    filterUploadFiles,
  ]);
  return (
    <div className={`print-image-cnt ${open ? 'open' : ''}`}>
      <h2 onClick={() => setOpen(!open)}>
        <div>
          <span>
            アップロード画像一覧
          </span>
          <span>
            &nbsp;{`(${imgData.length}枚)`}
          </span>
          <span>
            {imgData.length ?
              <Button
                label={'画像追加'}
                icon={<CiCirclePlus size="16px" strokeWidth="2px" />}
                onClick={onClickImageAdd}
                disabled={ordered}
                color='warning'
              />
            : <></>}
          </span>
        </div>
        <div>
          {!!progressView && (
            <div className="upload_progress">
              <ProgressBar
                percent={Number(progressView)}
                progressColor="#4B73E7"
                edgeColor="#666"
                label={
                  `${Number(progressView)}％ ( ${((progress?.done ?? 0) + (progress?.error ?? 0))} / ${((progress?.done ?? 0) + (progress?.error ?? 0) + (progress?.queue ?? 0))} )`
                }
              />
            </div>
          )}
          <SelectCondition selected={open} />
        </div>
      </h2>
      <hr />
      <div className={`print-image-wrap`}>
        <div className="print-image-list">
          {
            imgData.map((img) => (
              <PrintImage
                key={img.id}
                imgData={img}
                kijshopCd={kijshopCd}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}
